import {TextVariant} from "@pg-design/text-module";

import {PaginationSize} from "../types/PaginationSize";

export const getPaginationTextVariant = (size: PaginationSize) => {
    switch (size) {
        case PaginationSize.SM:
            return TextVariant.INFO_TXT_1;
        case PaginationSize.MD:
            return TextVariant.HEADLINE_6;
        case PaginationSize.LG:
        default:
            return TextVariant.HEADLINE_4;
    }
};
import {TextVariant} from "@pg-design/text-module";

import {PaginationSize} from "../types/PaginationSize";

export const getPaginationTextVariant = (size: PaginationSize) => {
    switch (size) {
        case PaginationSize.SM:
            return TextVariant.INFO_TXT_1;
        case PaginationSize.MD:
            return TextVariant.HEADLINE_6;
        case PaginationSize.LG:
        default:
            return TextVariant.HEADLINE_4;
    }
};
